/** Schedules one run at a time and waits until the user has stopped interacting. */
export function createAutoSyncScheduler(options: { canStart(): boolean; run(): Promise<void>; idleMs?: number; intervalMs?: number; now?(): number }) {
  const now = options.now ?? Date.now;
  const idleMs = options.idleMs ?? 10_000;
  const intervalMs = options.intervalMs ?? 30_000;
  let lastActivity = now(), running = false, stopped = false;
  async function tick() {
    if (stopped || running || now() - lastActivity < idleMs) return;
    try { if (!options.canStart()) return; } catch { return; }
    running = true;
    try { await options.run(); } catch { /* The next interval can retry. */ } finally { running = false; lastActivity = now(); }
  }
  function isIdle() { return now() - lastActivity >= idleMs; }
  const timer = setInterval(() => { void tick(); }, intervalMs);
  const initialTimer = setTimeout(() => { void tick(); }, idleMs);
  return { isIdle, activity() { lastActivity = now(); }, tick, stop() { stopped = true; clearTimeout(initialTimer); clearInterval(timer); } };
}
